<template>
  <div style="display: flex">
    <treeselect
      v-model="result"
      :multiple="true"
      :options="options"
      value-consists-of="LEAF_PRIORITY"
    >
    </treeselect>
  </div>
</template>

<script>
/*global _*/

export default {
  props: ['value', 'filter', 'brands'],
  computed: {
    options() {
      return _.map(this.brands, function(v) {
        return { id: v.id, label: v.name };
      });
    },
    result: {
      set(newval) {
        this.$emit('input', newval);
      },
      get() {
        return this.value;
      }
    }
  },
  methods: {
    ClearAll() {
      this.$emit('input', []);
    }
  }
};
</script>

<style lang="scss">
.multiselect__clear {
  position: absolute;
  top: 3px;
  right: 16px;
  height: 40px;
  width: 18px;
  display: block;
  font-size: 1.5em;
  z-index: 2;
  margin-right: 22px;
}
</style>
